import { useContext } from 'react';
import { SnackBarContext } from '../state/snackbar-provider/SnackBarProvider';

const useToast = () => {
  const { toast } = useContext(SnackBarContext);
  return toast;
};
export default useToast;
